import {Action, configureStore, ThunkAction} from "@reduxjs/toolkit"
import storage from 'redux-persist/lib/storage'
import {FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE,} from 'redux-persist'
import rootReducer from "./reducers/root-reducer"
import traceabilityApi from "@src/redux/services/traceabilityApi";
import {setupListeners} from "@reduxjs/toolkit/query";

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth'] // Only auth will be persisted
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(traceabilityApi.middleware),
})

setupListeners(store.dispatch)

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>

export const persistor = persistStore(store)
